// extracted by mini-css-extract-plugin
export default {"navList":"NavList_navList__-mjCz","active":"NavList_active__RGE1d"};